import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MessageCircle, LucideIconData } from 'lucide-angular';
import { IconComponent } from '../../shared/ui/icon/icon.component';

@Component({
  selector: 'app-whatsapp-fab',
  imports: [IconComponent],
  template: `
    <a
      class="whatsapp-fab"
      [href]="whatsappUrl()"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <app-icon [icon]="waIcon" [size]="24" color="#FFFFFF" />
    </a>
  `,
  styleUrl: './whatsapp-fab.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsAppFabComponent {
  whatsappUrl = input.required<string>();

  protected readonly waIcon: LucideIconData = MessageCircle;
}
